module.exports = __webpack_public_path__ + "assets/img/FAQ_header.55ba3f24.jpg";